import { dataProps } from './properties'

export const setDesignationMasterList = (state, payload) => {
    state.list = payload
}    

export const setDesignationMasterData = (state, payload) => {
    state.props = payload
} 

export const resetDesignationMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/designationMaster/mutations.js